import React from "react";
import { Card } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

export default function ReviewCard({ review, shouldRedirect = false }) {
  const navigate = useNavigate();
  const handleClick = () => {
    if (shouldRedirect) {
      navigate("/reviews");
    }
  };

  return (
    <div
      className="carousel-item-wrapper"
      onClick={handleClick}
      style={{ cursor: shouldRedirect ? 'pointer' : 'default' }}
    >
      <Card className="review-card">
        <Card.Body>
          <div className="review-content">
            <Card.Text className="review-text">"{review.text}"</Card.Text>
          </div>
          <div className="review-footer">
            <Card.Title className="review-author">— {review.name}</Card.Title>
            <div className="review-stars">★★★★★</div>
          </div>
        </Card.Body>
      </Card>
    </div>
  );
}
